import styled from 'styled-components'

const FullImageVideoStyle = styled.div`
	--fullWidthImagePaddingTop: 50.5%;

	.full-width-image-video {
		width: 100%;
		padding-top: var(--fullWidthImagePaddingTop);
	}

`

export default FullImageVideoStyle
